import { ROUTES } from '@/shared/config'
import { navigateToFx } from '@/shared/lib/providers'
import {
  $lastCreatedJingleCollectionId,
  JingleCollectionFormTabsKeys,
  lastCreatedJingleCollectionIdReset,
} from '@/widgets/JingleCollectionForm'
import { createEvent, sample } from 'effector'
import { createGate } from 'effector-react'
import { type NavigateOptions } from 'react-router-dom'

export const JingleCollectionCreatePageGate = createGate()
const navigateToEditJingleCollectionFx = createEvent<string>()
sample({
  clock: [$lastCreatedJingleCollectionId, JingleCollectionCreatePageGate.open],
  source: $lastCreatedJingleCollectionId,
  filter: (id): id is string => typeof id === 'string',
  target: navigateToEditJingleCollectionFx,
})
sample({
  clock: navigateToEditJingleCollectionFx,
  fn: (id) => ({
    to: ROUTES.JINGLES.EDIT_COLLECTION.replace(':id', id),
    options: {
      state: {
        activeTab: JingleCollectionFormTabsKeys.Jingles,
      },
    } as NavigateOptions,
  }),
  target: [navigateToFx, lastCreatedJingleCollectionIdReset],
})
